// Bundled ResizeObserver ponyfill — must be imported FIRST so it runs before
// MUI / SignaturePad evaluate. Replaces the old cdn.jsdelivr.net <script> that
// corporate proxies could block. See the module for the full rationale.
import 'utils/resizeObserverPonyfill';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { StrictMode } from 'react';
// third-party
import { Provider as ReduxProvider } from 'react-redux';

// project import
import { ConfigProvider } from 'contexts/ConfigContext';
import { persister, store } from 'store';
import App from './App';
import { PersistGate } from 'redux-persist/integration/react';
import { GlobalStyles } from '@mui/material';
import globalStyles from 'assets/globalStyles';

const container = document.getElementById('root');
// Check for null to avoid TypeScript assertion issues in the build
let root;
if (container) {
  root = createRoot(container);
} else {
  console.error('Root element not found!');
  throw new Error('Root element not found!');
}

// ==============================|| MAIN - REACT DOM RENDER  ||============================== //

root.render(
  <StrictMode>
    <ReduxProvider store={store}>
      <PersistGate loading={null} persistor={persister}>
        <ConfigProvider>
          <BrowserRouter>
            <GlobalStyles styles={globalStyles} />
            <App />
          </BrowserRouter>
        </ConfigProvider>
      </PersistGate>
    </ReduxProvider>
  </StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
